import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SharedServiceService {

    private _chatID = new BehaviorSubject<string>('');
    private _engageUrl = new BehaviorSubject<any>(null);
    private _engage_token = new BehaviorSubject<any>(null);
    private _iframeEndpoint = new BehaviorSubject<string>('dashboard/chat/liveChat/');

    constructor() { }

    // Getters as Observables
    get chatID$(): Observable<string> {
        return this._chatID.asObservable();
    }

    get engageUrl$(): Observable<any> {
        return this._engageUrl.asObservable();
    }

    get engage_token$(): Observable<any> {
        return this._engage_token.asObservable();
    }

    get iframeEndpoint$(): Observable<string> {
        return this._iframeEndpoint.asObservable();
    }

    // Setters
    set chatID(value: string) {
        this._chatID.next(value);
    }

    set engageUrl(value: any) {
        this._engageUrl.next(value);
    }

    set engage_token(value: any) {
        this._engage_token.next(value);
    }

    set iframeEndpoint(value: string) {
        this._iframeEndpoint.next(value);
    }
}
